import { Link } from "react-router-dom";

export default function FloatingHeader() {
  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-base-100 shadow-sm w-full">
      <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between">
        <Link
          to="/landing"
          className="text-3xl font-groteskLogo font-black hover:opacity-80 transition-opacity"
        >
          PEAK<span className="font-light text-base-content/60">^</span>
        </Link>
      </div>
    </header>
  );
}
